import { getCitiesByCode } from "../../../../service/CityService"
import { useQuery } from "react-query"

function useGetCities(tunnelData, departmentId) {
  const languageTag = tunnelData?.data?.order?.simplifiedJourneyEnabled
    ? undefined
    : tunnelData?.data?.order?.orderLanguageTag
  return useQuery({
    queryKey: ["query-cities-by-departmentId", departmentId, languageTag],
    queryFn: () =>
      getCitiesByCode(tunnelData, {
        departmentId,
        languageTag
      }),
    refetchOnWindowFocus: false,
    retry: 3,
    retryDelay: 5000,
    enabled: !!departmentId
  })
}

export default useGetCities
